"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flagsClient = void 0;
const unleash_proxy_client_1 = require("unleash-proxy-client");
const utils_1 = require("./utils");
const getMetricsConfig = () => {
    const serverUrl = (0, utils_1.getServerBaseUrl)();
    if (serverUrl && process.env.UNLEASH_SERVER_API_TOKEN) {
        return (0, utils_1.getDefaultServerConfig)();
    }
    return (0, utils_1.getDefaultClientConfig)();
};
/**
 * Simplified client SDK to work offline with pre-evaluated flags
 */
const flagsClient = (toggles = [], config) => {
    const { appName, url, clientKey } = {
        ...getMetricsConfig(),
        ...(config || {}),
    };
    const client = new unleash_proxy_client_1.UnleashClient({
        url,
        appName,
        clientKey,
        bootstrap: toggles,
        createAbortController: () => null,
        refreshInterval: 0,
        metricsInterval: 0,
        disableRefresh: true,
        bootstrapOverride: true,
        storageProvider: {
            get: async (_name) => { },
            save: async (_name, _value) => { },
        },
    });
    return client;
};
exports.flagsClient = flagsClient;
